<template>
  <ChartWrapper class="value-bar" :class="{minimal}" :status="status">
    <div class="root">
      <div class="marker current-marker noncompare" :style="{left: mainPos_marker+'%'}">
          <div class="top-value" :class="{doLeftTranslation: notEnoughSpace(this.mainPos)}">{{Math.round(mainValue)+'%'}} / {{currentYear}}</div>
          <div class="line" v-if="!minimal"></div>
          <!-- <div class="bottom-value">{{Math.round(mainValue)+'%'}}</div> -->
      </div>
      <div class="marker compare-marker compare" :style="{left: comparePos_marker+'%'}" v-if="compareData">
          <!-- <div class="top-value" :class="{doLeftTranslation: notEnoughSpace(this.comparePos)}">{{currentYear}}</div> -->
          <div class="line" v-if="!minimal"></div>
          <div class="bottom-value">{{Math.round(compareValue)+'%'}} / {{currentYear}}</div>
      </div>
      <div class="background-bar"></div>
      <div class="current-bar" :style="{width: mainPos+'%'}"></div>
      <div class="marker total-marker" :style="{left: refPos_marker+'%'}">
        <div class="top-value" v-if="!compareValue" :class="{doLeftTranslation: notEnoughSpace(this.refPos)}">{{lastYear}}</div>
        <div class="line"  v-if="!minimal"></div>
        <div class="bottom-value" v-if="!compareValue" :class="{doLeftTranslation: notEnoughSpace(this.refPos)}">100%</div>
      </div>
    </div>
  </ChartWrapper>
</template>

<script>
import d3 from '@/utils/d3_importer'
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'
import { mapState } from 'vuex'

export default {
  name: "ValueBar",
  props: {
    data:{
      required: true
    },
    compareData:{
      required: false
    },
    minimal:{
      default: false
    },
    status: null
  },
  components: {
    ChartWrapper
  },
  // mounted () {
  //   this.drawChart()
  // },
  // updated () {
  //   this.drawChart()
  // },

  computed: {
    ...mapState(['nodeInfo']),
    currentYear () {
      return this.$store.getters.dataCurrentYear
    },
    lastYear () {
      return this.currentYear - 1
    },
    scale () {
     return  d3.scaleLinear().domain([0,Math.max(100,this.mainValue)]).range([0,100])
    },
    mainValue () {
      // return this.data && Math.floor(this.data.value*Math.random()*5) || 0 //fake random
      return this.data && this.data.value || 0
    },
    mainPos () {
      return this.scale(this.mainValue)
    },
    compareValue () {
      // return this.data && Math.floor(this.data.value*Math.random()*5) || 0 //fake random
      return this.compareData && this.compareData.value || 0
    },
    comparePos () {
      return this.scale(this.compareValue)
    },
    refPos () {
      return this.scale(100)
    },
    // stackedPositions () {
    //   let first = this.mainPos<this.refPos ? {id:'mainPos',value: this.mainPos} : {id:'refPos',value: this.refPos}
    //   let second = first.id==='refPos' ? {id:'mainPos',value: this.mainPos} : {id:'refPos',value: this.refPos}
    //   if(first.value<20) first.value = 20
    //   if(second.value<first.value+10) second.value = first.value+10
    //   if(second.value>100) second.value = 100
    //   return {
    //     mainPos: first.id==='mainPos'?first.value:second.value,
    //     refPos: first.id==='refPos'?first.value:second.value,
    //   }

    // },
    mainPos_marker () {
      return this.mainPos
    },
    comparePos_marker () {
      return this.comparePos
    },
    refPos_marker () {
      return this.refPos
    }
  },
  methods: {
    notEnoughSpace (pos) {
      return pos > 80 //hardcoded to 80%...of the total width...
    }
    // drawChart () {

    // }
  }
}
</script>

<style scoped lang="stylus">
$bar-height = 55% //vw(85px)
$values-dist = 20% //vw(25px)
$bar-height-minimal = vw(8px)
$values-dist-minimal = vw(10px)
.value-bar
  position: relative
  
  .root
    position: absolute
    top: 50%
    transform: translate(0, -50%)
    width: 100%
    height 100%

    .background-bar
      background: #ddd
      height: $bar-height
      width: 100%
      position: absolute
      top: "calc((100% - %s)/2)" % ($bar-height)

    .current-bar
      background: $bs-blue
      height: $bar-height
      position: absolute
      top: "calc((100% - %s)/2)" % ($bar-height)
      transition width .3s

    .marker
      position: absolute
      transition left .3s
      height 100%
      z-index: 1;
      &.compare
        color $compare-color
      &.noncompare
        color $bs-blue
      .line
        position absolute
        border-left: dashed 1px
        height: "calc(%s + 2 * %s)" % ($bar-height $values-dist)
        top "calc((100% - %s)/2 - %s)" % ($bar-height $values-dist)
        
      .top-value,
      .bottom-value
        position: absolute
        white-space: nowrap
        m-font-size(11,13)
        font-family 'Lato'
        font-weight: $fw-semi-bold
        padding 0 4px
  
      .top-value
        // color $bs-blue
        top "calc((100% - %s)/2 - %s)" % ($bar-height $values-dist)

      .bottom-value
        bottom "calc((100% - %s)/2 - %s)" % ($bar-height $values-dist)

      .doLeftTranslation
        transform: translate(-100%, 0)

  &.minimal
    .root
      .background-bar,.current-bar
        height: $bar-height-minimal
        top: "calc((100% - %s)/2)" % ($bar-height-minimal)
      .marker
        .top-value,
        .bottom-value
          m-font-size(8,10)
          padding 0
        .top-value
          top "calc((100% - %s)/2 - %s)" % ($bar-height-minimal $values-dist-minimal)
        .bottom-value
          bottom "calc((100% - %s)/2 - %s)" % ($bar-height-minimal $values-dist-minimal)
</style>